/**
 * Košík functionality
 */
document.addEventListener("DOMContentLoaded", function () {
    const kosikContainer = document.querySelector(".moj-kosik");
    if (!kosikContainer) return;

    // Cart state
    let cartData = {};

    /**
     * Initialize cart functionality
     */
    function initCart() {
        bindEvents();
        initializeCartData();
        updateSummary();
    }

    /**
     * Bind all event listeners
     */
    function bindEvents() {
        // Add participant buttons
        document.addEventListener("click", function (e) {
            if (e.target.matches("[data-add-participant]")) {
                handleAddParticipant(e);
            }
        });

        // Remove participant buttons
        document.addEventListener("click", function (e) {
            if (e.target.closest(".remove-ucastnik")) {
                handleRemoveParticipant(e);
            }
        });

        // Remove course buttons
        document.addEventListener("click", function (e) {
            if (e.target.closest(".remove-kurz")) {
                handleRemoveCourse(e);
            }
        });

        // Quantity control buttons
        document.addEventListener("click", function (e) {
            if (e.target.matches(".quantity-btn")) {
                handleQuantityChange(e);
            }
        });

        // Form submission – na formuláři, aby se zachytilo i Enter a všechny způsoby odeslání
        const cartForm = document.querySelector(".woocommerce-cart-form");
        if (cartForm) {
            cartForm.addEventListener("submit", handleCheckout);
        }

        // Form input changes
        document.addEventListener("input", function (e) {
            if (e.target.matches('input[name*="participants"]')) {
                updateParticipantData();
            }
        });
    }

    /**
     * Initialize cart data from DOM
     */
    function initializeCartData() {
        const courseCards = document.querySelectorAll(".kurz-karta");
        courseCards.forEach((card) => {
            const cartItemKey = card.dataset.cartItem;
            const productId = card.dataset.productId;
            const participants = card.querySelectorAll(".ucastnik");

            cartData[cartItemKey] = {
                productId: productId,
                quantity: participants.length,
                participants: [],
            };
        });
    }

    /**
     * Handle add participant
     */
    function handleAddParticipant(e) {
        e.preventDefault();

        const button = e.target;
        const courseKey = button.dataset.course;
        const courseCard = document.querySelector(`[data-cart-item="${courseKey}"]`);
        const participantsList = courseCard.querySelector("[data-participants-list]");
        const currentParticipants = participantsList.querySelectorAll(".ucastnik");
        const nextParticipantNumber = currentParticipants.length + 1;

        // Create new participant element
        const participantElement = createParticipantElement(courseKey, nextParticipantNumber);
        participantsList.appendChild(participantElement);

        // Update cart data
        cartData[courseKey].quantity = nextParticipantNumber;

        // Update WooCommerce cart via AJAX
        updateWooCommerceQuantity(courseKey, nextParticipantNumber);

        // Update summary
        updateSummary();
    }

    /**
     * Handle remove participant
     */
    function handleRemoveParticipant(e) {
        e.preventDefault();

        const button = e.target.closest(".remove-ucastnik");
        const participantElement = button.closest(".ucastnik");
        const courseCard = button.closest(".kurz-karta");
        const courseKey = courseCard.dataset.cartItem;

        // Remove participant element
        participantElement.remove();

        // Renumber remaining participants
        renumberParticipants(courseCard);

        // Update cart data
        const remainingParticipants = courseCard.querySelectorAll(".ucastnik");
        cartData[courseKey].quantity = remainingParticipants.length;

        // Update WooCommerce cart via AJAX
        updateWooCommerceQuantity(courseKey, remainingParticipants.length);

        // Update summary
        updateSummary();
    }

    /**
     * Handle remove course
     */
    function handleRemoveCourse(e) {
        e.preventDefault();

        const button = e.target.closest(".remove-kurz");
        const courseKey = button.dataset.removeCourse;

        // Remove from WooCommerce cart via AJAX
        removeFromCart(courseKey);
    }

    /**
     * Handle quantity change from summary
     */
    function handleQuantityChange(e) {
        e.preventDefault();

        const button = e.target;
        const action = button.dataset.action;
        const cartItemKey = button.dataset.cartItem;
        const quantityDisplay = document.querySelector(`[data-quantity="${cartItemKey}"]`);
        const courseCard = document.querySelector(`[data-cart-item="${cartItemKey}"]`);

        let currentQuantity = parseInt(quantityDisplay.textContent);
        let newQuantity = action === "increase" ? currentQuantity + 1 : currentQuantity - 1;

        // Minimum 1 participant
        if (newQuantity < 1) {
            newQuantity = 1;
        }

        // Update quantity display
        quantityDisplay.textContent = newQuantity;

        // Update participants in course card
        updateParticipantsInCourse(courseCard, newQuantity);

        // Update WooCommerce cart
        updateWooCommerceQuantity(cartItemKey, newQuantity);

        // Update summary
        updateSummary();
    }

    /**
     * Create participant element
     */
    function createParticipantElement(courseKey, participantNumber) {
        const template = document.querySelector("#participant-template");
        const participantElement = template.content.cloneNode(true);

        const container = participantElement.querySelector(".ucastnik");
        container.dataset.participant = participantNumber;

        const numberSpan = participantElement.querySelector(".participant-number");
        numberSpan.textContent = participantNumber;

        const inputs = participantElement.querySelectorAll("input, select");
        inputs.forEach((input) => {
            const fieldName = input.type === "email" ? "email" : input.type === "tel" ? "phone" : input.tagName === "SELECT" ? "prefix" : "name";

            input.name = `participants[${courseKey}][${participantNumber}][${fieldName}]`;
            input.id = `participant_${participantNumber}_${fieldName}`;
        });

        const labels = participantElement.querySelectorAll("label");
        labels.forEach((label, index) => {
            const input = inputs[index];
            if (input) {
                label.setAttribute("for", input.id);
            }
        });

        return participantElement;
    }

    /**
     * Renumber participants after removal
     */
    function renumberParticipants(courseCard) {
        const participants = courseCard.querySelectorAll(".ucastnik");
        const courseKey = courseCard.dataset.cartItem;

        participants.forEach((participant, index) => {
            const participantNumber = index + 1;
            participant.dataset.participant = participantNumber;

            const header = participant.querySelector("h4");
            header.textContent = `Údaje účastníka ${participantNumber}`;

            const inputs = participant.querySelectorAll("input, select");
            inputs.forEach((input) => {
                const fieldName = input.name.split("[")[3].replace("]", "");
                input.name = `participants[${courseKey}][${participantNumber}][${fieldName}]`;
                input.id = `participant_${participantNumber}_${fieldName}`;
            });

            const labels = participant.querySelectorAll("label");
            labels.forEach((label, labelIndex) => {
                const input = inputs[labelIndex];
                if (input) {
                    label.setAttribute("for", input.id);
                }
            });

            // Show/hide remove button
            const removeButton = participant.querySelector(".remove-ucastnik");
            if (removeButton) {
                removeButton.style.display = participantNumber === 1 ? "none" : "block";
            }
        });
    }

    /**
     * Update participants in course card based on quantity
     */
    function updateParticipantsInCourse(courseCard, newQuantity) {
        const participantsList = courseCard.querySelector("[data-participants-list]");
        const currentParticipants = participantsList.querySelectorAll(".ucastnik");
        const currentQuantity = currentParticipants.length;
        const courseKey = courseCard.dataset.cartItem;

        if (newQuantity > currentQuantity) {
            // Add participants
            for (let i = currentQuantity + 1; i <= newQuantity; i++) {
                const participantElement = createParticipantElement(courseKey, i);
                participantsList.appendChild(participantElement);
            }
        } else if (newQuantity < currentQuantity) {
            // Remove participants (from the end)
            for (let i = currentQuantity; i > newQuantity; i--) {
                const lastParticipant = participantsList.querySelector(`[data-participant="${i}"]`);
                if (lastParticipant) {
                    lastParticipant.remove();
                }
            }
        }

        // Update cart data
        cartData[courseKey].quantity = newQuantity;
    }

    /**
     * Update WooCommerce cart quantity via AJAX
     */
    function updateWooCommerceQuantity(cartItemKey, quantity) {
        const formData = new FormData();
        formData.append("cart_item_key", cartItemKey);
        formData.append("quantity", quantity);
        formData.append("action", "update_cart_quantity");

        // Use localized nonce if available, fallback to DOM
        const nonce = typeof ajax_object !== "undefined" && ajax_object.nonce ? ajax_object.nonce : getWooCommerceNonce();
        formData.append("nonce", nonce);

        // Use localized URL if available
        const url = typeof ajax_object !== "undefined" && ajax_object.ajax_url ? ajax_object.ajax_url : typeof ajaxurl !== "undefined" ? ajaxurl : "/wp-admin/admin-ajax.php";

        fetch(url, {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    updateSummaryPrices(data.data);

                    // Update header cart count manually
                    if (data.data.cart_count !== undefined) {
                        const headerCartCount = document.querySelector(".header-cart-link .count");
                        if (headerCartCount) {
                            headerCartCount.textContent = data.data.cart_count;
                        }
                    }

                    // Refresh cart fragments (fallback)
                    if (typeof jQuery !== "undefined") {
                        jQuery(document.body).trigger("wc_fragment_refresh");
                    }
                }
            })
            .catch((error) => {
                console.error("Error updating cart:", error);
            });
    }

    /**
     * Remove item from cart via AJAX
     */
    function removeFromCart(cartItemKey) {
        const formData = new FormData();
        formData.append("cart_item_key", cartItemKey);
        formData.append("action", "remove_cart_item");

        // Use localized nonce if available, fallback to DOM
        const nonce = typeof ajax_object !== "undefined" && ajax_object.nonce ? ajax_object.nonce : getWooCommerceNonce();
        formData.append("nonce", nonce);

        // Use localized URL if available
        const url = typeof ajax_object !== "undefined" && ajax_object.ajax_url ? ajax_object.ajax_url : typeof ajaxurl !== "undefined" ? ajaxurl : "/wp-admin/admin-ajax.php";

        fetch(url, {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    // Remove course card from DOM
                    const courseCard = document.querySelector(`[data-cart-item="${cartItemKey}"]`);
                    if (courseCard) {
                        courseCard.remove();
                    }

                    // Remove from summary
                    const summaryItem = document.querySelector(`[data-summary-item="${cartItemKey}"]`);
                    if (summaryItem) {
                        summaryItem.remove();
                    }

                    // Update cart data
                    delete cartData[cartItemKey];

                    // Update summary
                    updateSummary();

                    // Update header cart count manually
                    if (data.data.cart_count !== undefined) {
                        const headerCartCount = document.querySelector(".header-cart-link .count");
                        if (headerCartCount) {
                            headerCartCount.textContent = data.data.cart_count;
                        }
                    }

                    // Refresh cart fragments (fallback)
                    if (typeof jQuery !== "undefined") {
                        jQuery(document.body).trigger("wc_fragment_refresh");
                    }

                    // Check if cart is empty
                    if (Object.keys(cartData).length === 0) {
                        window.location.reload();
                    }
                }
            })
            .catch((error) => {
                console.error("Error removing from cart:", error);
            });
    }

    /**
     * Format price
     */
    function formatPrice(price) {
        // Format as CZK currency
        return new Intl.NumberFormat("cs-CZ", {
            style: "currency",
            currency: "CZK",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(price);
    }

    /**
     * Update prices optimistically
     */
    function updatePricesOptimistically() {
        let total = 0;

        const summaryItems = document.querySelectorAll(".souhrn-polozka");

        summaryItems.forEach((item) => {
            const key = item.dataset.summaryItem;
            // Get unit price from DOM (added via PHP)
            const unitPrice = parseFloat(item.dataset.unitPrice || 0);

            // Get quantity from cartData
            const quantity = cartData[key] ? cartData[key].quantity : 0;

            const lineTotal = unitPrice * quantity;
            total += lineTotal;

            // Update line total
            const lineTotalEl = item.querySelector(`[data-line-total="${key}"]`);
            if (lineTotalEl) {
                lineTotalEl.textContent = formatPrice(lineTotal);
            }
        });

        // Update cart total
        const cartTotalEl = document.querySelector("[data-cart-total]");
        if (cartTotalEl) {
            cartTotalEl.textContent = formatPrice(total);
        }
    }

    /**
     * Update header cart count optimistically
     */
    function updateHeaderCountOptimistically() {
        let totalCount = 0;
        Object.keys(cartData).forEach((key) => {
            totalCount += cartData[key].quantity;
        });

        const headerCartCounts = document.querySelectorAll(".header-cart-link .count");
        headerCartCounts.forEach((count) => {
            count.textContent = totalCount;
        });
    }

    /**
     * Update summary section
     */
    function updateSummary() {
        // Update quantity displays
        Object.keys(cartData).forEach((cartItemKey) => {
            const quantityDisplay = document.querySelector(`[data-quantity="${cartItemKey}"]`);
            if (quantityDisplay) {
                quantityDisplay.textContent = cartData[cartItemKey].quantity;
            }
        });

        updateParticipantData();
        updateHeaderCountOptimistically();
    }

    /**
     * Update summary prices from AJAX response
     */
    function updateSummaryPrices(priceData) {
        if (priceData.line_totals) {
            Object.keys(priceData.line_totals).forEach((cartItemKey) => {
                const lineTotalElement = document.querySelector(`[data-line-total="${cartItemKey}"]`);
                if (lineTotalElement) {
                    lineTotalElement.innerHTML = priceData.line_totals[cartItemKey];
                }
            });
        }

        if (priceData.cart_total) {
            const cartTotalElement = document.querySelector("[data-cart-total]");
            if (cartTotalElement) {
                cartTotalElement.innerHTML = priceData.cart_total;
            }
        }

        if (priceData.cart_total_with_tax) {
            const cartTotalWithTaxElement = document.querySelector("[data-cart-total-with-tax]");
            if (cartTotalWithTaxElement) {
                cartTotalWithTaxElement.innerHTML = priceData.cart_total_with_tax;
            }
        }
    }

    /**
     * Update participant data in hidden field
     */
    function updateParticipantData() {
        const participantDataField = document.querySelector("#participants-data");
        if (participantDataField) {
            participantDataField.value = JSON.stringify(collectParticipantData());
        }
    }

    /**
     * Collect all participant data
     */
    function collectParticipantData() {
        const data = {};

        Object.keys(cartData).forEach((cartItemKey) => {
            data[cartItemKey] = [];

            const courseCard = document.querySelector(`[data-cart-item="${cartItemKey}"]`);
            const participants = courseCard.querySelectorAll(".ucastnik");

            participants.forEach((participant) => {
                const participantData = {
                    name: participant.querySelector('input[name*="[name]"]')?.value || "",
                    email: participant.querySelector('input[name*="[email]"]')?.value || "",
                    prefix: participant.querySelector('select[name*="[prefix]"]')?.value || "+420",
                    phone: participant.querySelector('input[name*="[phone]"]')?.value || "",
                };

                data[cartItemKey].push(participantData);
            });
        });

        return data;
    }

    /**
     * Handle checkout
     */
    function handleCheckout(e) {
        const gdprConsent = document.querySelector("#gdpr-consent");

        if (!gdprConsent || !gdprConsent.checked) {
            e.preventDefault();
            alert("Musíte souhlasit se zpracováním osobních údajů.");
            return;
        }

        // Validate all participant forms
        const isValid = validateParticipantForms();

        if (!isValid) {
            e.preventDefault();
            alert("Vyplňte prosím všechna povinná pole.");
            return;
        }

        // Prevent default submission to avoid navigating before AJAX completes
        e.preventDefault();

        // Update participant data before submission
        updateParticipantData();

        // Save participant data via AJAX before proceeding to final checkout
        saveParticipantDataToSession(e.target);
    }

    /**
     * Validate all participant forms
     */
    function validateParticipantForms() {
        const requiredFields = document.querySelectorAll(".ucastnik input[required]");

        for (let field of requiredFields) {
            if (!field.value.trim()) {
                field.focus();
                return false;
            }

            // Email validation
            if (field.type === "email" && !isValidEmail(field.value)) {
                field.focus();
                return false;
            }
        }

        return true;
    }

    /**
     * Email validation
     */
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    /**
     * Save participant data to session
     */
    function saveParticipantDataToSession(formElement) {
        const formData = new FormData();
        formData.append("participants_data", JSON.stringify(collectParticipantData()));
        formData.append("gdpr_consent", document.querySelector("#gdpr-consent").checked ? "on" : "");
        formData.append("action", "save_participant_data");
        formData.append("nonce", getWooCommerceNonce());

        const submitBtn = document.querySelector("#proceed-to-checkout");
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.style.opacity = "0.7";
            submitBtn.innerText = "Zpracovávám...";
        }

        const url = typeof ajax_object !== "undefined" && ajax_object.ajax_url ? ajax_object.ajax_url : typeof ajaxurl !== "undefined" ? ajaxurl : "/wp-admin/admin-ajax.php";

        fetch(url, {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    console.log("Participant data saved to session");
                    if (formElement) formElement.submit();
                } else {
                    console.error("Error saving participant data:", data);
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.style.opacity = "1";
                        submitBtn.innerText = "Přejít k pokladně";
                    }
                }
            })
            .catch((error) => {
                console.error("Error saving participant data:", error);
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.style.opacity = "1";
                    submitBtn.innerText = "Přejít k pokladně";
                }
            });
    }

    /**
     * Get WooCommerce nonce
     */
    function getWooCommerceNonce() {
        const nonceField = document.querySelector('[name="woocommerce-cart-nonce"]');
        return nonceField ? nonceField.value : "";
    }

    // Initialize cart functionality
    initCart();
});
